Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.Context3DVertexBufferFormat = module.exports.default = {
	BYTES_4: "bytes4",
	FLOAT_1: "float1",
	FLOAT_2: "float2",
	FLOAT_3: "float3",
	FLOAT_4: "float4"
};